export default `
<div ng-if="$ctrl.staticPage && !$ctrl.user" ng-bind-html="$ctrl.staticPage.content | trustAsHtml"></div>
<div ng-if="!$ctrl.staticPage || $ctrl.user">
  <ut-unauthenticated-home [brands]="$ctrl.brands" ng-if="!$ctrl.user" style="height: 100%"></ut-unauthenticated-home>
  <h1 class="sr-only">uTest Homepage</h1>
  <ut-dashboard ng-if="$ctrl.user && $ctrl.useNewDashboard"></ut-dashboard>
  <dashboard ng-if="$ctrl.user && !$ctrl.useNewDashboard"></dashboard>
</div>
`;
